export default (props, e) => {
	let target;

	if(props.targetId != null) {
		target = document.querySelector('[id^="' + props.targetId + '"]');
	}
	if(typeof (target) !== 'undefined') {
		target.click(e);
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/autoClick.js